import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("marquee-banner")
export class MarqueeBanner extends LitElement {
  override createRenderRoot() {
    return this;
  }

  override render() {
    const marqueeSpans = [];
    for (let i = 0; i <= 15; i++) {
      marqueeSpans.push(html` <span
        class="twf-text-xl twf-font-extrabold twf-font-coco twf-mr-3 twf-text-[#330066]"
      >
        Yay to cashback
      </span>`);
    }

    return html`<div
      class="twf-h-10 twf-bg-[#C4FF2F] twf-relative twf-flex twf-overflow-x-hidden"
    >
      <div class="twf-animate-marquee twf-whitespace-nowrap twf-py-[6px]">
        ${marqueeSpans}
      </div>

      <div
        class="twf-absolute twf-animate-marquee2 twf-whitespace-nowrap twf-py-[6px]"
      >
        ${marqueeSpans}
      </div>
    </div>`;
  }
}
